import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7 11V7L2 12L7 17V13H17V17L22 12L17 7V11H7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MoveHorizontal"
);
